import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Card, { CardContent } from "material-ui/Card";

const styles = (theme) => ({
  card: {
    display: "flex",
    height: "100%",
    flexWrap: "wrap",
  },
  details: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  content: {
    // flex: '1 0 auto',
  },
  cover: {
    height: 253,
    display: "block",
    width: "100%",
  },
  clickToCall: {
    color: "#f44336",
  },
  icon: {
    display: "block",
    height: "100%",
    width: "100%",
  },
  contentRight: {
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    paddingLeft: "50px",
  },
  iconLink: {
    height: "30px",
    width: "30px",
    display: "block",
    marginRight: "10px",
    cursor: "pointer",
  },
  instagramLink: {
    width: "44px",
    height: "34px",
    opacity: 0.8,
  },
});

class App extends Component {
  render() {
    const { classes } = this.props;

    return (
      <Grid item xs={12} md={4}>
        <Card className={classes.card}>
          <div className={classes.details}>
            <CardContent className={classes.content}>
              <Typography variant="title" gutterBottom>
                Adresse
              </Typography>
              <Typography variant="subheading" gutterBottom>
                <a
                  target="_blank"
                  style={{
                    color: "black",
                    fontSize: "14px",
                    lineHeight: "2px",
                    textDecoration: "underline",
                    textDecorationColor: "rgba(0, 0, 0, 0.2)",
                  }}
                  href="https://maps.app.goo.gl/7stb2bMqJE5JRzRaA"
                >
                  34 Avenue du Général de Gaulle / RDC Tour YOUFIRST
                  <br />
                  92800 Puteaux
                </a>
              </Typography>

              <Typography noWrap>
                <a className={classes.clickToCall} href="tel:0147752252">
                  01 47 75 22 52
                </a>
              </Typography>
              <Typography
                variant="subheading"
                gutterBottom
                style={{ marginTop: "16px", fontWeight: 500 }}
              >
                Stationnement conseillé
              </Typography>
              <Typography style={{ fontSize: "14px" }}>
                <a
                  target="_blank"
                  style={{
                    color: "black",
                    textDecoration: "underline",
                    textDecorationColor: "rgba(0, 0, 0, 0.2)",
                  }}
                  href="https://maps.app.goo.gl/d1tm4zXdfKJaRDn19"
                >
                  Rue Lavoisier, Puteaux
                </a>
              </Typography>
            </CardContent>
            {/* <CardContent
              className={classnames(classes.content, classes.contentRight)}
            >
              <a
                href="https://www.facebook.com/pages/category/Sushi-Restaurant/Sakura-Puteaux-443366836109163/"
                target="_blank"
                className={classes.iconLink}
                title="facebook"
              >
                <img className={classes.icon} src="/images/facebook.png" />
              </a>
              <a
                href="https://www.instagram.com/sakura_puteaux"
                target="_blank"
                className={classnames(classes.iconLink, classes.instagramLink)}
                title="instagram"
              >
                <img className={classes.icon} src="/images/instagram.png" />
              </a>
            </CardContent> */}
          </div>
          {/* <CardMedia className={classes.cover}>
            <Map
              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCgcKzoLjyf17WcI-ap6JzPsC4acwsV1NI&v=3.exp&libraries=geometry,drawing,places"
              loadingElement={<div style={{ height: `100%`, width: "100%" }} />}
              containerElement={
                <div style={{ height: `100%`, width: "100%" }} />
              }
              mapElement={<div style={{ height: `100%`, width: "100%" }} />}
            />
          </CardMedia> */}
        </Card>
      </Grid>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/components/Place/Place.js